import { keycloak, LOGIN_OPTIONS } from './keycloak'
import { env } from '../config/env'

/**
 * fetch wrapper for BFF/gateway calls: refreshes the token if it's about to
 * expire, then attaches it as a Bearer header. On a dead session it kicks the
 * user back to Keycloak rather than silently failing.
 *
 * `cache: 'no-store'` is forced. The browser HTTP cache keys on the URL, not
 * the bearer token, so a stored `/me/*` response could otherwise be shown to
 * the next person on this browser.
 */
export async function authFetch(path: string, init: RequestInit = {}) {
  try {
    await keycloak.updateToken(30) // refresh if it expires within 30s
  } catch {
    keycloak.login(LOGIN_OPTIONS) // refresh failed → session gone → re-login
    throw new Error('session expired')
  }
  const res = await fetch(`${env.VITE_BFF_URL}${path}`, {
    ...init,
    cache: 'no-store',
    headers: { ...init.headers, Authorization: `Bearer ${keycloak.token}` },
  })
  if (res.status === 401) keycloak.login(LOGIN_OPTIONS)
  // The BFF gates routes by scope: a missing scope is a 403 with a structured
  // body. Surface it instead of letting callers treat it as generic data.
  if (res.status === 403) {
    const body = await res.clone().json().catch(() => ({}))
    if (body?.error === 'insufficient_scope') {
      throw new Error(`insufficient_scope: ${body.required_scope ?? 'unknown'}`)
    }
  }
  return res
}
